module.exports = __webpack_public_path__ + "img/thumbnail_RedRiverHog_f_normal.d4ca8ace.png";